import React, { Component } from 'react';
import { Label, Button, RichTextInput, FileUpload } from 'app/components/Basics';
import  MediaUrlHandler  from 'app/pages/question/MediaUrlHandler';
import { Select } from '@ecosystem/ui-lib/core/components/Select';
import { Card } from '@ecosystem/ui-lib/core/components/Card';
import { ButtonIcon } from '@ecosystem/ui-lib/core/components/ButtonIcon';
import { Icons } from '@ecosystem/ui-lib/core/components/Icon';
import { Input as EcoInput } from '@ecosystem/ui-lib/core/components/Input';
import { Checkbox } from '@ecosystem/ui-lib/core/components/Checkbox';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { ReactComponent as PlusIcon } from 'app/assets/icons/Plus.svg';
import {QuestionFormContext} from '../../QuestionContext'
import { GetLanguageTexts, addMissingLanguageTexts } from '../../QuestionTextHelper';
import QuestionService from "app/services/question.service";
import  GetErrorMessage  from '../../../../helpers/error-message'
import './TabOptionsComponent.scss';

// Stable unique ID generator for option keys (uses WeakMap to avoid polluting option objects)
let _optionUidCounter = 0;
const _optionUidMap = new WeakMap();
function ensureOptionUid(option) {
    if (!_optionUidMap.has(option)) {
        _optionUidMap.set(option, '_opt_' + (++_optionUidCounter));
    }
    return _optionUidMap.get(option);
}

// Helper to reorder items in an array via drag-and-drop
function reorderOptions(options, fromIndex, toIndex) {
    const result = [...options];
    const [moved] = result.splice(fromIndex, 1);
    result.splice(toIndex, 0, moved);
    result.forEach((opt, index) => { opt.sortOrder = index; });
    return result;
}

function getEffectiveQuestionType(selectedQuestion, gridSubType) {
    if (selectedQuestion?.questionType === 'GGROUP') {
        return gridSubType || 'SS';
    }

    return selectedQuestion?.questionType;
}

const GROUP_MODE_OPTIONS = [
    {value: 'fixed', label: "Fixed"},
    {value: 'random', label: "Random"}
];

// Generic card component for a single option group
class CardOptionsGroup extends Component {

    onDragEnd = (result) => {
        if (!result.destination) return;
        if (result.source.droppableId !== result.destination.droppableId) return;
        var match = result.source.droppableId.match(/group-(\d+)-options/);
        if (!match) return;
        this.props.onReorder(parseInt(match[1]), result.source.index, result.destination.index);
    }

    multiSelectMaxAnswersHandler = event => {
        var selectedQuestion = this.context.selectedQuestion;
        const val = event.target.value;
        selectedQuestion.multiSelectMax = val === '' ? null : parseInt(val, 10);
        this.context.updateSelectedQuestion(selectedQuestion);
    }

    render() {
        const { groups, fixedMode } = this.props;
        const allOptions = groups.flatMap(g => g.options);
        const modeValue = GROUP_MODE_OPTIONS.find(o => o.value === fixedMode);
        const isFixedMode = fixedMode === 'fixed';

        return (
            <Card className="CardOptionsGroupComponent">
                <div className="form-row">
                    <div className="form-row-left">
                        <div className="field-option-order">
                            <Label tooltip="Fixed: all options keep their position. Random: non-fixed options are shuffled.">Order</Label>
                            <Select isDisabled={!this.context.canChangeData}
                                name="tierMode" isSearchable={false}
                                value={modeValue}
                                options={GROUP_MODE_OPTIONS}
                                onChange={val => this.props.onModeChange(val.value)}/>
                        </div>
                        {this.props.showMaxField && 
                            (<div className="field-label-max">
                                <Label tooltip="Set a maximum number of answers that a respondent can give">Max. number of answers</Label>
                                <EcoInput type="number" id="maximumLabelText" name="maximumLabelText" value={this.context.selectedQuestion.multiSelectMax} onChange={this.multiSelectMaxAnswersHandler.bind(this)}></EcoInput>
                            </div>)}
                    </div>
                    <div className="form-row-right">
                        {this.props.addButtons}
                    </div>
                </div>
                <DragDropContext onDragEnd={this.onDragEnd}>
                    <table className="Table OptionList Draggable">
                        <thead>
                            <tr>
                                <th className="AppFormTableHeader column-drag"></th>
                                <th className="AppFormTableHeader column-code">Code</th>
                                <th className="AppFormTableHeader column-label"><Label tooltip="This is the answer label shown to the respondent.">Label</Label></th>
                                <th className="AppFormTableHeader column-fixed"><Label tooltip="Sets the option to have a fixed position">Fixed</Label></th>
                                <th className="AppFormTableHeader column-image"><Label tooltip="Image for standard options, text hint for custom answers">Image / Hint</Label></th>
                                <th className="AppFormTableHeader column-remove">Remove</th>
                            </tr>
                        </thead>
                        {groups.map(({ groupSortOrder, options }) => (
                            <Droppable key={groupSortOrder} droppableId={`group-${groupSortOrder}-options`}>
                                {(provided) => (
                                    <tbody {...provided.droppableProps} ref={provided.innerRef} className="Table__Body">
                                        {options.map((opt, index) => (
                                            <Draggable key={ensureOptionUid(opt)} draggableId={`g${groupSortOrder}-${ensureOptionUid(opt)}`} index={index} isDragDisabled={!this.context.canChangeData}>
                                                {(provided) => (
                                                    <tr ref={provided.innerRef} {...provided.draggableProps}>
                                                        <td className="column-drag" {...provided.dragHandleProps}><span style={{cursor:'grab'}}>&#x2630;</span></td>
                                                        <td className="column-code">
                                                            <EcoInput type="number" id={`code_${ensureOptionUid(opt)}`} value={opt.value}
                                                                disabled={!this.context.canChangeData}
                                                                onChange={this.props.onCodeChange.bind(null, ensureOptionUid(opt))}
                                                                style={{width: '80px'}} />
                                                        </td>
                                                        <td className="column-label">
                                                            <RichTextInput key={ensureOptionUid(opt)} id={ensureOptionUid(opt)}
                                                                disabled={!this.context.canChangeData}
                                                                value={GetLanguageTexts(opt.texts, this.context.selectedLanguageCode).text}
                                                                onValueChange={this.props.onTextChange}
                                                                ctrlsPosition="right" maxLines={2}
                                                                error={this.props.getValidationError(opt.value)} />
                                                        </td>
                                                        <td className="column-fixed">
                                                            <Checkbox checked={opt.isFixed === 1}
                                                                disabled={isFixedMode || !this.context.canChangeData}
                                                                onChange={this.props.onFixedChange.bind(null, ensureOptionUid(opt))}/>
                                                        </td>
                                                        <td className="column-image">
                                                                {opt.isOpentext 
                                                                    ? <EcoInput id={`texthint_${ensureOptionUid(opt)}`} placeholder="Text hint"
                                                                        disabled={!this.context.canChangeData}
                                                                        value={GetLanguageTexts(opt.texts, this.context.selectedLanguageCode).textHint || ''}
                                                                        onChange={this.props.onTextHintChange.bind(null, ensureOptionUid(opt))} />
                                                                    : <MediaUrlHandler key={`image_${ensureOptionUid(opt)}`} id={opt.value} url={opt.imageUrl}
                                                                        mediaType="image" entityType="option" optionValue={opt.value} handleUpload={this.props.onImageUpload} />}
                                                        </td>
                                                        <td className="column-remove">
                                                            <ButtonIcon isDisabled={!this.context.canChangeData} onClick={() => this.props.removeOption(ensureOptionUid(opt))} icon={Icons.Close}/>
                                                        </td>
                                                    </tr>
                                                )}
                                            </Draggable>
                                        ))}
                                        {provided.placeholder}
                                    </tbody>
                                )}
                            </Droppable>
                        ))}
                    </table>
                </DragDropContext>
                <div style={{display: allOptions.length > 0 ? 'none' : 'block' }}>
                    <p className='EmptyOptionListInfoTitle'>Option list is empty</p>
                    <p className='EmptyOptionListInfoText'>{this.props.emptyMessage}</p>
                </div>
                {this.props.errorMessage ? <span className="table_options_error">{this.props.errorMessage}</span> : ""}
            </Card>
        );
    }
}

class CardOptionsCustom extends Component{
    constructor(props){
        super(props);
        this.state = {
            codeLabel:<div>999</div>,
            disabled: false
        }
    }

    changeFieldAmount (value){        
        if(value.value < 2){
            this.setState({codeLabel:<div>999</div>})
        }else{
            var startCode = 999 - value.value + 1;
            this.setState({codeLabel:<div>{startCode}<br/>... 999</div>});
        }
    }   

    hasCustomOption() {
        if ((this.getCustomOption() != null && this.getCustomOption() !== '') || this.context.selectedQuestion.hasCustomOption === true) {
            return true
        }
        else {
            return false;
        }
    }

    customAnswerCheckHandler = event => {
        var selectedQuestion = this.context.selectedQuestion;        
        if (!event.target.checked) {
            selectedQuestion.hasCustomOption = false;
            var index = selectedQuestion.options.findIndex(o=>o.value === 999);
            if (index > -1) {
                selectedQuestion.options.splice(index, 1);                
            }            
            this.context.updateSelectedQuestion(selectedQuestion);
        }
        else {
            selectedQuestion.hasCustomOption = true;  
            this.context.updateSelectedQuestion(selectedQuestion);
            this.setCustomOption('New custom answer text');               
        }                
    }

    customLabelHandler = event => {        
        this.setCustomOption(event.target.value);
    }

    getCustomOption() {
        if (!this.context.selectedQuestion ||
            !this.context.selectedQuestion.options) {
                return undefined;
            }

        let customOption = this.context.selectedQuestion.options.find(o=>o.value === 999);

        if (customOption) {
            return GetLanguageTexts(customOption.texts, this.context.selectedLanguageCode).text;
        }
        else {
            return undefined;
        }
    }

    setCustomOption(newCustomValue) {        
        var selectedQuestion = this.context.selectedQuestion;
        var index = selectedQuestion.options.findIndex(o=>o.value === 999);
        if (newCustomValue && newCustomValue !== '') {            
            
            var customOption = {
                value: 999,
                text: newCustomValue,                
                texts: []
            }

            if (index > -1) {
                customOption = selectedQuestion.options[index];
            }
           
            if (customOption.texts.find(t=>t.languageCode === this.context.selectedLanguageCode) == null) {
                customOption.texts.push({ languageCode: this.context.selectedLanguageCode});                
            }            
            GetLanguageTexts(customOption.texts, this.context.selectedLanguageCode).text = newCustomValue;

            if (index === -1 ) {                
                selectedQuestion.options.push(customOption)
            } 
            else {
                selectedQuestion.options[index] = customOption;
            }
        }        

        this.context.updateSelectedQuestion(selectedQuestion);        
    }

    render() {
        return (
            <Card className="CardOptionsCustomComponent">
                <div className="form-row">
                    <div className="form-row-left">
                        <Checkbox label="Custom Answer" checked={this.hasCustomOption()} onChange={this.customAnswerCheckHandler} />
                    </div>
                </div>
                <div className="form-row">
                    <div className="form-row-left">
                        <div className="field-custom-code">
                            {this.state.codeLabel}
                        </div>
                        <div className="field-custom-label">
                            <Label tooltip="This is the answer label shown to the respondent.">Label</Label>
                            <EcoInput id="customlabel" placeholder="- input label -" 
                            disabled={!this.context.canChangeData} value={this.getCustomOption()} 
                            onChange={this.customLabelHandler}  key={this.context.selectedQuestion.hasCustomOption}                          
                            ></EcoInput>
                            
                        </div>
                        {/* <div className="field-custom-maxlength">
                            <Label>Max. Length</Label>
                            <EcoInput id="custommaxlength" name="custommaxlength" disabled={this.state.disabled}>
                            </EcoInput>
                        </div> */}
                        {this.props.multiFieldSelect ? <div className="field-custom-fieldamount">
                            <Label tooltip={(<div>Description of <br/>Fields</div>)}>Fields</Label>
                            <Select name="customfields" isSearchable={false}
                                defaultValue={{value:"1",label:"1"}}
                                isDisabled={!this.context.canChangeData}
                                onChange={(value)=>{this.changeFieldAmount(value)}}
                                options={[
                                    {value:"1",label:"1"},{value:"2",label:"2"},{value:"3",label:"3"},
                                    {value:"4",label:"4"},{value:"5",label:"5"},{value:"6",label:"6"},
                                    {value:"7",label:"7"},{value:"8",label:"8"},{value:"9",label:"9"},{value:"10",label:"10"},
                                ]}/>
                        </div> : ""}                       
                    </div>
                    <div className="form-row-right">
                        
                    </div>
                </div>
            </Card>
        );

    }

}

class TabOptions extends Component {    
	
    constructor(props){
        super(props);
        this.state = {
            modeOverrides: {} // { [groupSortOrder]: 'fixed' | 'random' }
        }
    }

	getNoOptionsValidationError() {		
		let validationError = this.props.errors.find(e => e.field === "options");		
		return validationError != null ? validationError.errorMessage : "";
	}

	getEmptyOptionTextValidationError(answerValue) {		
		let validationError = this.props.errors.find(e => e.field === 'option_' + answerValue);		
		return validationError != null ? validationError.errorMessage : "";
	}

    addOptionToGroup(group, isOptout, isOpentext) {
        var selectedQuestion = this.context.selectedQuestion;
        var groupOptions = selectedQuestion.options.filter(o => (o.groupSortOrder ?? 0) === group);

        // Determine new value code based on option type (regular: start at 1, alternative/optout: start at 999)
        var tierOptions = isOptout
            ? selectedQuestion.options.filter(o => o.isOptout)
            : selectedQuestion.options.filter(o => !o.isOptout);
        var newValue = isOptout ? 999 : 1;
        if (tierOptions.length > 0) {
            newValue = Math.max(...tierOptions.map(o => o.value)) + 1;
        }

        var defaultMode = isOptout ? 'fixed' : 'random';
        var newOption = {
            value: newValue,
            text: "",
            texts: isOpentext ? [{ languageCode: this.context.selectedLanguageCode, text: "" }] : [],
            isOptout: isOptout,
            isOpentext: isOpentext,
            isFixed: this.getGroupMode(group, defaultMode) === 'fixed' ? 1 : 0,
            groupSortOrder: group,
            sortOrder: groupOptions.length
        };
        if (isOpentext) {
            newOption.textHint = "";
        }

        selectedQuestion.options.push(newOption);
        this.context.updateSelectedQuestion(selectedQuestion);
        if (!isOpentext) {
            addMissingLanguageTexts(selectedQuestion, this.context.selectedLanguageCode, this.context.updateSelectedQuestion.bind(this));
        }
    }

    removeOptionHandler(optionValue) {
        var selectedQuestion = this.context.selectedQuestion;		
        if (selectedQuestion.options) {
			selectedQuestion.options = selectedQuestion.options.filter(f => ensureOptionUid(f) !== optionValue)			
            this.context.updateSelectedQuestion(selectedQuestion);
        }
    }

    onOptionTextChange(newText, optionUid) {		
		var selectedQuestion = this.context.selectedQuestion;
		var option = selectedQuestion.options.find(o => ensureOptionUid(o) === optionUid);
		if (option) {	
            GetLanguageTexts(option.texts, this.context.selectedLanguageCode).text = newText;
			this.context.updateSelectedQuestion(selectedQuestion);
		}
    }

    onCodeChange(optionUid, event) {
        var newValue = parseInt(event.target.value, 10);
        if (isNaN(newValue)) return;
        var selectedQuestion = this.context.selectedQuestion;
        var option = selectedQuestion.options.find(o => ensureOptionUid(o) === optionUid);
        if (option) {
            option.value = newValue;
            this.context.updateSelectedQuestion(selectedQuestion);
        }
    }

    fixedChangeHandler(optionUid, event) {       
		var selectedQuestion = this.context.selectedQuestion;        
        var option = selectedQuestion.options.find(o => ensureOptionUid(o) === optionUid);
        option.isFixed = event.target.checked === true ? 1 : 0;		    
		this.context.updateSelectedQuestion(selectedQuestion);	
	}

	handleImageUpload(file, optionUid) {		
		var selectedQuestion = this.context.selectedQuestion;	
		var option = selectedQuestion.options.find(o => ensureOptionUid(o) === optionUid);		
		if (!option) return;
		var optionValue = option.value;
		this.context.toggleUiBlock(true);
		QuestionService.UploadImageToQuestion(selectedQuestion.id, optionValue, file)
			.then(response =>{
				option.imageUrl = response.data;
				this.context.updateSelectedQuestion(selectedQuestion);
				this.context.toggleUiBlock(false);
			return response;          
			})
			.catch(error => {
			  this.context.toggleUiBlock(false);			  
			  let errorMessage = GetErrorMessage(error);
			  console.log("errorMessage on catch");
			  console.log(errorMessage);			  
			});
	}

    onReorderGroupOptions(group, sourceIndex, destinationIndex) {
        var selectedQuestion = this.context.selectedQuestion;
        var groupOptions = selectedQuestion.options
            .filter(o => (o.groupSortOrder ?? 0) === group)
            .sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0));
        var reordered = reorderOptions(groupOptions, sourceIndex, destinationIndex);
        // Replace group options in full list
        selectedQuestion.options = selectedQuestion.options
            .filter(o => (o.groupSortOrder ?? 0) !== group)
            .concat(reordered);
        this.context.updateSelectedQuestion(selectedQuestion);
    }

    onTextHintChange(optionUid, event) {
        var selectedQuestion = this.context.selectedQuestion;
        var option = selectedQuestion.options.find(o => ensureOptionUid(o) === optionUid);
        if (option) {
            var newTextHint = event.target.value;
            GetLanguageTexts(option.texts, this.context.selectedLanguageCode).textHint = newTextHint;
            this.context.updateSelectedQuestion(selectedQuestion);
        }
    }

    getGroupOptions(group) {
        return this.context.selectedQuestion.options
            .filter(o => (o.groupSortOrder ?? 0) === group)
            .sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0));
    }

    getGroupMode(group, defaultMode = 'random') {
        if (this.state.modeOverrides[group] !== undefined) {
            return this.state.modeOverrides[group];
        }
        var groupOpts = this.getGroupOptions(group);
        if (groupOpts.length === 0) return defaultMode;
        return groupOpts.every(o => o.isFixed === 1) ? 'fixed' : 'random';
    }

    onGroupModeChange(group, newMode) {
        var modeOverrides = { ...this.state.modeOverrides, [group]: newMode };
        var selectedQuestion = this.context.selectedQuestion;

        if (newMode === 'random') {
            selectedQuestion.options
                .filter(o => (o.groupSortOrder ?? 0) === group)
                .forEach(o => { o.isFixed = 0; });
        }

        if (!selectedQuestion._groupFixedModes) selectedQuestion._groupFixedModes = {};
        selectedQuestion._groupFixedModes[group] = newMode;

        this.setState({ modeOverrides });
        this.context.updateSelectedQuestion(selectedQuestion);
    }

    renderGroupCard(group, addButtons, emptyMessage, showMaxField, defaultMode = 'random') {
        return (
            <CardOptionsGroup
                groups={[{ groupSortOrder: group, options: this.getGroupOptions(group) }]}
                fixedMode={this.getGroupMode(group, defaultMode)}
                onModeChange={(mode) => this.onGroupModeChange(group, mode)}
                showMaxField={showMaxField}
                addButtons={addButtons}
                emptyMessage={emptyMessage}
                removeOption={this.removeOptionHandler.bind(this)}
                onReorder={this.onReorderGroupOptions.bind(this)}
                onCodeChange={this.onCodeChange.bind(this)}
                onTextChange={this.onOptionTextChange.bind(this)}
                onFixedChange={this.fixedChangeHandler.bind(this)}
                onImageUpload={this.handleImageUpload.bind(this)}
                onTextHintChange={this.onTextHintChange.bind(this)}
                getValidationError={this.getEmptyOptionTextValidationError.bind(this)}
                errorMessage={group === 0 ? this.getNoOptionsValidationError() : ""}
            />
        );
    }

    render() {
        var qt = getEffectiveQuestionType(this.context.selectedQuestion, this.context.gridSubType);
        var hasOpenGroups = qt === 'SSOPEN' || qt === 'MSOPEN' || qt === 'NUMERIC';

        // Each group card has add buttons for both option types within its tier
        // Groups 0,1 = regular tier; groups 2,3 = alternative tier
        // SS/MS: only groups 0 and 1 (no custom answers, so each group just has +Option or +Alt Option)
        // SSOPEN/MSOPEN/NUMERIC: groups 0,1,2,3 — each group has both add buttons for its tier

        return (
            <div className={`TabOptionsComponent content-box ${this.getNoOptionsValidationError() ? "error" : ""}`} >
                {this.renderGroupCard(0, <>
                    <Button disabled={!this.context.canChangeData} secondary icon={<PlusIcon/>}
                        onClick={() => this.addOptionToGroup(0, false, false)}>Option</Button>
                    {hasOpenGroups &&
                        <Button disabled={!this.context.canChangeData} secondary icon={<PlusIcon/>}
                            onClick={() => this.addOptionToGroup(0, false, true)}>Custom Answer</Button>}
                </>, hasOpenGroups
                    ? <>Please, add options via <span className='span-box'>+Option</span> or <span className='span-box'>+Custom Answer</span></>
                    : <>Please, add options via <span className='span-box'>+Option</span></>,
                    this.props.isMulti
                )}
                {hasOpenGroups && this.renderGroupCard(1, <>
                    <Button disabled={!this.context.canChangeData} secondary icon={<PlusIcon/>}
                        onClick={() => this.addOptionToGroup(1, false, false)}>Option</Button>
                    <Button disabled={!this.context.canChangeData} secondary icon={<PlusIcon/>}
                        onClick={() => this.addOptionToGroup(1, false, true)}>Custom Answer</Button>
                </>, <>Please, add options via <span className='span-box'>+Option</span> or <span className='span-box'>+Custom Answer</span></>,
                    false
                )}
                {this.renderGroupCard(hasOpenGroups ? 2 : 1, <>
                    <Button disabled={!this.context.canChangeData} secondary icon={<PlusIcon/>}
                        onClick={() => this.addOptionToGroup(hasOpenGroups ? 2 : 1, true, false)}>Alternative Option</Button>
                    {hasOpenGroups &&
                        <Button disabled={!this.context.canChangeData} secondary icon={<PlusIcon/>}
                            onClick={() => this.addOptionToGroup(2, true, true)}>Alternative Custom Answer</Button>}
                </>, hasOpenGroups
                    ? <>Please, add options via <span className='span-box'>+Alternative Option</span> or <span className='span-box'>+Alternative Custom Answer</span></>
                    : <>Please, add options via <span className='span-box'>+Alternative Option</span></>,
                    false, 'fixed'
                )}
                {hasOpenGroups && this.renderGroupCard(3, <>
                    <Button disabled={!this.context.canChangeData} secondary icon={<PlusIcon/>}
                        onClick={() => this.addOptionToGroup(3, true, false)}>Alternative Option</Button>
                    <Button disabled={!this.context.canChangeData} secondary icon={<PlusIcon/>}
                        onClick={() => this.addOptionToGroup(3, true, true)}>Alternative Custom Answer</Button>
                </>, <>Please, add options via <span className='span-box'>+Alternative Option</span> or <span className='span-box'>+Alternative Custom Answer</span></>,
                    false, 'fixed'
                )}
            </div>
        );
    }
}
TabOptions.contextType = QuestionFormContext;
CardOptionsGroup.contextType = QuestionFormContext;

// Backward-compatible wrapper used by TabScale, TabRating, TabInput
class CardOptionsAlternative extends Component {

    constructor(props) {
        super(props);
        this.state = { modeOverrides: {} };
    }

    addOptionToGroup(group, isOptout, isOpentext) {
        var selectedQuestion = this.context.selectedQuestion;
        var groupOptions = selectedQuestion.options.filter(o => (o.groupSortOrder ?? 0) === group);
        var tierOptions = selectedQuestion.options.filter(o => o.isOptout);
        var newValue = 999;
        if (tierOptions.length > 0) {
            newValue = Math.max(...tierOptions.map(o => o.value)) + 1;
        }
        var newOption = {
            value: newValue, text: "",
            texts: isOpentext ? [{ languageCode: this.context.selectedLanguageCode, text: "" }] : [],
            isOptout: isOptout, isOpentext: isOpentext,
            isFixed: this.getGroupMode(group) === 'fixed' ? 1 : 0,
            groupSortOrder: group, sortOrder: groupOptions.length
        };
        if (isOpentext) newOption.textHint = "";
        selectedQuestion.options.push(newOption);
        this.context.updateSelectedQuestion(selectedQuestion);
    }

    removeOptionHandler(optionValue) {
        var selectedQuestion = this.context.selectedQuestion;
        if (selectedQuestion.options) {
            selectedQuestion.options = selectedQuestion.options.filter(f => ensureOptionUid(f) !== optionValue);
            this.context.updateSelectedQuestion(selectedQuestion);
        }
    }

    onOptionTextChange(newText, optionUid) {
        var selectedQuestion = this.context.selectedQuestion;
        var option = selectedQuestion.options.find(o => ensureOptionUid(o) === optionUid);
        if (option) {
            GetLanguageTexts(option.texts, this.context.selectedLanguageCode).text = newText;
            this.context.updateSelectedQuestion(selectedQuestion);
        }
    }

    onCodeChange(optionUid, event) {
        var newValue = parseInt(event.target.value, 10);
        if (isNaN(newValue)) return;
        var selectedQuestion = this.context.selectedQuestion;
        var option = selectedQuestion.options.find(o => ensureOptionUid(o) === optionUid);
        if (option) { option.value = newValue; this.context.updateSelectedQuestion(selectedQuestion); }
    }

    fixedChangeHandler(optionUid, event) {
        var selectedQuestion = this.context.selectedQuestion;
        var option = selectedQuestion.options.find(o => ensureOptionUid(o) === optionUid);
        option.isFixed = event.target.checked === true ? 1 : 0;
        this.context.updateSelectedQuestion(selectedQuestion);
    }

    handleImageUpload(file, optionUid) {
        var selectedQuestion = this.context.selectedQuestion;
        var option = selectedQuestion.options.find(o => ensureOptionUid(o) === optionUid);
        if (!option) return;
        var optionValue = option.value;
        this.context.toggleUiBlock(true);
        QuestionService.UploadImageToQuestion(selectedQuestion.id, optionValue, file)
            .then(response => {
                var opt = selectedQuestion.options.find(o => ensureOptionUid(o) === optionUid);
                opt.imageUrl = response.data;
                this.context.updateSelectedQuestion(selectedQuestion);
                this.context.toggleUiBlock(false);
            })
            .catch(error => {
                this.context.toggleUiBlock(false);
                console.log(GetErrorMessage(error));
            });
    }

    onReorderGroupOptions(group, sourceIndex, destinationIndex) {
        var selectedQuestion = this.context.selectedQuestion;
        var groupOptions = selectedQuestion.options
            .filter(o => (o.groupSortOrder ?? 0) === group)
            .sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0));
        var reordered = reorderOptions(groupOptions, sourceIndex, destinationIndex);
        selectedQuestion.options = selectedQuestion.options
            .filter(o => (o.groupSortOrder ?? 0) !== group).concat(reordered);
        this.context.updateSelectedQuestion(selectedQuestion);
    }

    onTextHintChange(optionUid, event) {
        var selectedQuestion = this.context.selectedQuestion;
        var option = selectedQuestion.options.find(o => ensureOptionUid(o) === optionUid);
        if (option) {
            var newTextHint = event.target.value;
            GetLanguageTexts(option.texts, this.context.selectedLanguageCode).textHint = newTextHint;
            this.context.updateSelectedQuestion(selectedQuestion);
        }
    }

    getValidationError(answerValue) {
        if (!this.props.errors) return "";
        let validationError = this.props.errors.find(e => e.field === 'option_' + answerValue);
        return validationError != null ? validationError.errorMessage : "";
    }

    getGroupOptions(group) {
        return this.context.selectedQuestion.options
            .filter(o => (o.groupSortOrder ?? 0) === group)
            .sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0));
    }

    getGroupMode(group, defaultMode = 'fixed') {
        if (this.state.modeOverrides[group] !== undefined) return this.state.modeOverrides[group];
        var groupOpts = this.getGroupOptions(group);
        if (groupOpts.length === 0) return defaultMode;
        return groupOpts.every(o => o.isFixed === 1) ? 'fixed' : 'random';
    }

    onGroupModeChange(group, newMode) {
        var modeOverrides = { ...this.state.modeOverrides, [group]: newMode };
        var selectedQuestion = this.context.selectedQuestion;

        if (newMode === 'random') {
            selectedQuestion.options
                .filter(o => (o.groupSortOrder ?? 0) === group)
                .forEach(o => { o.isFixed = 0; });
        }

        if (!selectedQuestion._groupFixedModes) selectedQuestion._groupFixedModes = {};
        selectedQuestion._groupFixedModes[group] = newMode;
        this.setState({ modeOverrides });
        this.context.updateSelectedQuestion(selectedQuestion);
    }

    renderGroupCard(group, addButtons, emptyMessage) {
        return (
            <CardOptionsGroup
                groups={[{ groupSortOrder: group, options: this.getGroupOptions(group) }]}
                fixedMode={this.getGroupMode(group)}
                onModeChange={(mode) => this.onGroupModeChange(group, mode)}
                showMaxField={false}
                addButtons={addButtons}
                emptyMessage={emptyMessage}
                removeOption={this.removeOptionHandler.bind(this)}
                onReorder={this.onReorderGroupOptions.bind(this)}
                onCodeChange={this.onCodeChange.bind(this)}
                onTextChange={this.onOptionTextChange.bind(this)}
                onFixedChange={this.fixedChangeHandler.bind(this)}
                onImageUpload={this.handleImageUpload.bind(this)}
                onTextHintChange={this.onTextHintChange.bind(this)}
                getValidationError={this.getValidationError.bind(this)}
                errorMessage=""
            />
        );
    }

    render() {
        var qt = getEffectiveQuestionType(this.context.selectedQuestion, this.context.gridSubType);
        var hasOpenGroups = qt === 'SSOPEN' || qt === 'MSOPEN' || qt === 'NUMERIC';
        var altGroup = hasOpenGroups ? 2 : 1;
        return (
            <>
                {this.renderGroupCard(altGroup, <>
                    <Button disabled={!this.context.canChangeData} secondary icon={<PlusIcon/>}
                        onClick={() => this.addOptionToGroup(altGroup, true, false)}>Alternative Option</Button>
                    {hasOpenGroups &&
                        <Button disabled={!this.context.canChangeData} secondary icon={<PlusIcon/>}
                            onClick={() => this.addOptionToGroup(altGroup, true, true)}>Alternative Custom Answer</Button>}
                </>, hasOpenGroups
                    ? <>Please, add options via <span className='span-box'>+Alternative Option</span> or <span className='span-box'>+Alternative Custom Answer</span></>
                    : <>Please, add options via <span className='span-box'>+Alternative Option</span></>
                )}
                {hasOpenGroups && this.renderGroupCard(3, <>
                    <Button disabled={!this.context.canChangeData} secondary icon={<PlusIcon/>}
                        onClick={() => this.addOptionToGroup(3, true, false)}>Alternative Option</Button>
                    <Button disabled={!this.context.canChangeData} secondary icon={<PlusIcon/>}
                        onClick={() => this.addOptionToGroup(3, true, true)}>Alternative Custom Answer</Button>
                </>, <>Please, add options via <span className='span-box'>+Alternative Option</span> or <span className='span-box'>+Alternative Custom Answer</span></>
                )}
            </>
        );
    }
}
CardOptionsAlternative.contextType = QuestionFormContext;

export default TabOptions;
export {TabOptions, CardOptionsAlternative, CardOptionsGroup};